module.exports = __webpack_public_path__ + "static/media/app-condutor-carrorama-1.ac4d7768.jp2";